import { styled } from '@mui/material';

import { Trans } from 'react-i18next';

import { Typography } from '@app-velocity/ui';

import { RepeatIcon } from '@app-velocity/icons';

import { SinglePath } from '../../../../types';
import { PathRunPreview } from '../PathRunPreview';

const StyledPathBreakdownSection = styled('div')(({ theme }) => ({
  padding: `${theme.spacing(5)} 0`,
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(5),
}));

const StyledSubheader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1),
  svg: {
    fill: 'var(--text-text-primary-color)',
  },
}));

const StyledSubtitle = styled(Typography)({
  fontSize: 16,
});

const RunsList = styled('ul')(({ theme }) => ({
  padding: 0,
  margin: 0,
  listStyleType: 'none',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(5),
}));

export type PathBreakdownSectionProps = {
  path: SinglePath;
};

export const PathBreakdownSection = ({ path }: PathBreakdownSectionProps) => {
  const runs = path.single ?? [];

  return (
    <StyledPathBreakdownSection>
      <StyledSubheader>
        <RepeatIcon />
        <StyledSubtitle component="h3">
          <Trans
            i18nKey={`prototypes:report.paths.breakdown.${path.type}.runs`}
            values={{
              count: runs.length,
            }}
            components={{
              tag: <strong />,
            }}
          />
        </StyledSubtitle>
      </StyledSubheader>
      <RunsList>
        {runs.map((run, index) => (
          <li key={run.reviewId ?? index}>
            <PathRunPreview path={path} run={run} index={index} />
          </li>
        ))}
      </RunsList>
    </StyledPathBreakdownSection>
  );
};
